import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { OVERRIDE_SERVER_URL_KEY, SERVER_URL_KEY } from '../app.constants';
import { AnalyticsService } from './analytics.service';

@Injectable({ providedIn: 'root' })
export class ServerUrl {
  readonly #localStorageService = inject(LocalStorageService);
  readonly #analyticsService = inject(AnalyticsService);

  constructor() {
    this.#analyticsService.setUserProperty('apiUrl', this.get());
  }

  public get(): string {
    const overrideUrl = this.getLocalOverrideUrl();
    const url = this.#localStorageService.retrieve(SERVER_URL_KEY);
    if (url && overrideUrl) {
      const replaced = url.replace(/https?:\/\/localhost:\d+/, overrideUrl);
      if (replaced) {
        return replaced;
      }
    }

    return url;
  }

  public getRoot(): string {
    return this.get().replace(/\/mobile$/, '');
  }

  public put(serverUrl: string) {
    this.#localStorageService.store(SERVER_URL_KEY, serverUrl);
    this.#analyticsService.setUserProperty('apiUrl', serverUrl);
  }

  public clear() {
    this.#localStorageService.clear(SERVER_URL_KEY);
  }

  public getLocalOverrideUrl() {
    return this.#localStorageService.retrieve(OVERRIDE_SERVER_URL_KEY);
  }

  public putLocalOverrideUrl(serverUrl: string) {
    this.#localStorageService.store(OVERRIDE_SERVER_URL_KEY, serverUrl);
    this.#analyticsService.setUserProperty('apiUrl', serverUrl);
  }

  public clearLocalOverrideUrl() {
    this.#localStorageService.clear(OVERRIDE_SERVER_URL_KEY);
  }
}
